/**
 * Zentrale Telefon-Formatierung für CH-Nummern
 */

/**
 * Normalisiert eine Telefonnummer zu nur Ziffern und +
 * @param {string} s - Telefonnummer
 * @returns {string} - Normalisierte Nummer (nur Ziffern und +)
 */
export function normalizePhone(s) {
  return String(s || "").replace(/[^\d+]/g, "");
}

/**
 * Formatiert eine CH-Telefonnummer schön: "+41 62 391 25 26" oder "062 391 25 26"
 * @param {string|number} raw - Rohe Telefonnummer
 * @returns {string} - Formatierte Nummer
 */
export function formatCHPhone(raw) {
  if (raw == null || raw === "") return "";
  
  let s = String(raw);
  const plus = s.trim().startsWith("+");
  s = s.replace(/[^\d+]/g, "");
  if (plus && !s.startsWith("+")) s = "+" + s.replace(/[^\d]/g, "");
  
  // 0041 → +41
  if (s.startsWith("0041")) s = "+" + s.slice(2);
  
  // International: +41 xx xxx xx xx
  if (s.startsWith("+41")) {
    let rest = s.slice(3).replace(/\D/g, "");
    if (rest.startsWith("0")) rest = rest.slice(1);
    const g = [];
    if (rest.length > 0) g.push(rest.slice(0, 2));
    if (rest.length > 2) g.push(rest.slice(2, 5));
    if (rest.length > 5) g.push(rest.slice(5, 7));
    if (rest.length > 7) g.push(rest.slice(7, 9));
    return "+41 " + g.filter(Boolean).join(" ");
  }
  
  // National: beginnt mit 0 → 0xx xxx xx xx
  let digits = s.replace(/\D/g, "");
  if (digits.startsWith("0")) {
    const g = [];
    if (digits.length > 0) g.push(digits.slice(0, 3));
    if (digits.length > 3) g.push(digits.slice(3, 6));
    if (digits.length > 6) g.push(digits.slice(6, 8));
    if (digits.length > 8) g.push(digits.slice(8, 10));
    return g.filter(Boolean).join(" ");
  }
  
  // Fallback: 3-3-2-2 Format
  const g = [];
  if (digits.length > 0) g.push(digits.slice(0, 3));
  if (digits.length > 3) g.push(digits.slice(3, 6));
  if (digits.length > 6) g.push(digits.slice(6, 8));
  if (digits.length > 8) g.push(digits.slice(8, 10));
  return g.filter(Boolean).join(" ");
}

/**
 * Erstellt einen tel: Link aus einer Telefonnummer
 * @param {string} raw - Telefonnummer
 * @returns {string|null} - tel: Link oder null
 */
export function toTelHref(raw) {
  const d = String(raw || "").replace(/[^\d+]/g, "");
  if (!d) return null;
  // 0041 → +41, führende 0 nach +41 entfernen
  let s = d.replace(/^0041/, "+41");
  if (s.startsWith("+41")) s = "+41" + s.slice(3).replace(/^0/, "");
  return `tel:${s}`;
}

/**
 * Erstellt einen mailto: Link aus einer E-Mail-Adresse
 * @param {string} raw - E-Mail-Adresse
 * @returns {string|null} - mailto: Link oder null
 */
export function toMailHref(raw) {
  const s = String(raw || "").trim();
  return s ? `mailto:${s}` : null;
}
